module.exports = __webpack_public_path__ + "static/5-a33c125e2fd622a9617a7ec6a1ba13cf.jpg";